// extracted by mini-css-extract-plugin
export default {"reviewCount":"_1vJOjm7YBGKm3G33CwaA85 b-profile-card__review-count","icon":"_2kMWitysfCJtbLZnouc1wR b-profile-card__review-count-icon"};